import { createContext } from "react";

// i am saying react that i wanna use context api so create a context api for me
//syntax to create context

const sidebarContext = createContext();

export default sidebarContext;